import { render, staticRenderFns } from "./JournalDetail.vue?vue&type=template&id=c061242a&scoped=true&"
import script from "./JournalDetail.vue?vue&type=script&lang=js&"
export * from "./JournalDetail.vue?vue&type=script&lang=js&"
import style0 from "./JournalDetail.vue?vue&type=style&index=0&id=c061242a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c061242a",
  null
  
)

export default component.exports